import { classNames } from "@utils/classNames";
import { FC } from "react";
import { useFormContext } from "react-hook-form";
import { NewTag, TagType } from "types/tags";

interface Props {
  heading?: string;
  availableTagTypes: TagType[];
  tags: NewTag[];
  name: string;
}

export const TagsGroup: FC<Props> = ({
  heading,
  availableTagTypes,
  tags,
  name,
}) => {
  // Get form context.
  const { watch, setValue } = useFormContext();

  // Get currently assigned tags.
  const assignedTags = watch(name);

  // Method: toggleAssignedTag.
  const toggleAssignedTag = (tagId: string) => {
    const tag = assignedTags.find((tag) => tag.id === tagId);
    if (tag) {
      setValue(
        name,
        assignedTags.filter((tag) => tag.id !== tagId),
        { shouldValidate: false }
      );
    } else {
      setValue(name, [...assignedTags, { id: tagId, score: 100 }], {
        shouldValidate: false,
      });
    }
  };

  return (
    <fieldset className="">
      {heading && <div className="mb-1 text-sm font-medium">{heading}</div>}
      <div className="">
        {tags
          .filter((tag) => availableTagTypes.includes(tag.type))
          .map((tag) => (
            <button
              key={tag.id}
              type="button"
              className={classNames(
                "mr-0.5 mb-1 px-2 py-1 text-sm border rounded-sm bg-gray-100 hover:bg-gray-200",
                assignedTags?.findIndex((t) => t.id === tag.id) > -1 &&
                  "bg-blue-300 hover:bg-blue-400"
              )}
              onClick={() => {
                toggleAssignedTag(tag.id);
              }}
            >
              {tag.label || tag.id}
            </button>
          ))}
      </div>
    </fieldset>
  );
};
